import React, { FC, forwardRef } from 'react';
import { default as MuiCard } from '@material-ui/core/Card';
import { CardProps } from './types';
import useStyles from './style';
import { cx } from '../customEmotion';

const Card: FC<CardProps> = forwardRef(({
  children,
  className,
  ...restProps
}, ref) => {
  const { root } = useStyles(restProps);

  return (
    <MuiCard
      ref={ref}
      className={cx(root, className)}
      {...restProps}
    >
      {children}
    </MuiCard>
  );
});

export default Card;
